import React, { useState } from "react";
import "../Styles/signUp.css";
import logo from "../asset/Image/logo.png";
import { CircularProgress } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logoBlack from "../asset/Image/logo1.png";
import { BiArrowBack } from "react-icons/bi";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import api from "../util/axios";

const ResetPassword = () => {
    const { state } = useLocation();
    const email = state?.email || "";
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [sign, setSign] = useState({
        otp: "",
        password: "",
        confirmPassword: "",
    });

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    }

    const handleChange = ({ target: { name, value } }: any) => {
        setSign({ ...sign, [name]: value });
    };


    const handleResendOpt = () => {
        if (!email) {
            toast.error("Some error occured, please try again!")
            setTimeout(() => {
                navigate(-1)
            }, 3000);
        }
        setLoading(true);
        api
            .post(
                "/auth/business/email-verification",
                {
                    email: email,
                }
            )
            .then((res) => {
                toast.success("Mail sent. Check your inbox!");
                setLoading(false);
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message);
                setLoading(false);
            });
    }

    const handleSubmit = (e: any) => {
        setLoading(true);
        e.preventDefault();
        if (sign.password !== sign.confirmPassword) {
            toast.error("Passwords do not match!");
            setLoading(false);
            return;
        }

        api
            .post(
                "/auth/password/validate/business",
                {
                    otp: sign.otp,
                    password: sign.password,
                    confirmPassword: sign.confirmPassword,
                }
            )
            .then((res) => {
                toast.success("Password reset successful!");
                setLoading(false);
                setTimeout(() => {
                    navigate("/");
                }, 3000)
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message);
                setLoading(false);
            });
    };

    return (
        <div className="auth">
            <ToastContainer />
            <div className="left">
                <div>
                    <img src={logo} alt="" />

                    <div className="leftCon1">
                        <h2>Reset Password</h2>
                        <p>Complete password reset by entering the fields below</p>
                        <form onSubmit={handleSubmit}>
                            <div className="input1">
                                <label
                                    htmlFor="otp"
                                >
                                    Otp <span className="text-red-600">*</span>
                                </label>
                                <input
                                    type="text"
                                    maxLength={6}
                                    name="otp"
                                    required
                                    value={sign.otp || ""}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="input1">
                                <label
                                    htmlFor="password"
                                >
                                    New Password <span className="text-red-600">*</span>
                                </label>
                                <div className="inputPass !w-full">
                                    <input
                                        type={passwordVisible ? "text" : "password"}
                                        name="password"
                                        id="password"
                                        required
                                        value={sign.password}
                                        onChange={handleChange}
                                    />
                                    {passwordVisible ? (
                                        <AiFillEyeInvisible
                                            className="loginEye"
                                            onClick={togglePasswordVisibility}
                                        />
                                    ) : (
                                        <AiFillEye
                                            className="loginEye"
                                            onClick={togglePasswordVisibility}
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="input1">
                                <label
                                    htmlFor="confirmPassword"
                                >
                                    Confirm Password <span className="text-red-600">*</span>
                                </label>
                                <div className="inputPass !w-full">
                                    <input
                                        type={passwordVisible ? "text" : "password"}
                                        name="confirmPassword"
                                        required
                                        id="confirmPassword"
                                        value={sign.confirmPassword}
                                        onChange={handleChange}
                                    />
                                    {passwordVisible ? (
                                        <AiFillEyeInvisible
                                            className="loginEye"
                                            onClick={togglePasswordVisibility}
                                        />
                                    ) : (
                                        <AiFillEye
                                            className="loginEye"
                                            onClick={togglePasswordVisibility}
                                        />
                                    )}
                                </div>
                            </div>
                            <p onClick={handleResendOpt} className="forget cursor-pointer !text-blue-600 !text-base">
                                {loading ? (
                                    "Please wait..."
                                ) : ("Resend otp?"
                                )}
                            </p>
                            <div className="flex w-full gap-2 mt-16">
                                <button onClick={(() => navigate(-1))} className="bg-white text-black flex gap-1 justify-center items-center"><span><BiArrowBack /></span>Back</button>
                                <button type="submit" className="bg-blue-600 text-white">
                                    {loading ? (
                                        <CircularProgress
                                            style={{ color: "#fff", width: "25px", height: "25px" }}
                                        />
                                    ) : (
                                        "Continue"
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className="right">
                <div className="rightCon">
                    <h4>Oneflare Business Suite</h4>
                    <h2>
                        <h2>
                            You don't <span>Remember?</span>  Don’t worry we got you{" "}
                            <span>covered.</span>
                        </h2>
                    </h2>
                </div>

                <img src={logoBlack} alt="" className="logoBottom" />
            </div>
        </div>
    );
};

export default ResetPassword;
